/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lockreason1Inputs */

const en__field_lockreason1 = /** @type {(inputs: _Field_Lockreason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock reason`)
};

/**
* | output |
* | --- |
* | "Lock reason" |
*
* @param {_Field_Lockreason1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_lockreason1 = /** @type {((inputs?: _Field_Lockreason1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lockreason1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_lockreason1(inputs)
});
export { _field_lockreason1 as "_field_lockReason" }